import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = ["data-content-id"]
const _hoisted_2 = {
  key: 0,
  class: "news-card__image-wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "timer news-card__timer"
}
const _hoisted_4 = { class: "timer__text" }
const _hoisted_5 = {
  key: 2,
  class: "news-card__gallery-badge"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Galéria ")
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 4,
  class: "news-card__excerpt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Play = _resolveComponent("Play")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Image = _resolveComponent("Image")!
  const _component_GalleryFull = _resolveComponent("GalleryFull")!
  const _component_minute_by_minute_lead = _resolveComponent("minute-by-minute-lead")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["news-card", {
      'news-card--shrink': _ctx.size === 'shrink',
      'news-card--large': _ctx.size === 'large',
      'news-card--medium': _ctx.size === 'medium',
      'news-card--bordered': _ctx.showBorder,
      'news-card--highlighted': _ctx.cardHighlighted
    }]),
    "data-content-id": _ctx.content.id
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.navigation ? 'nav-link' : 'div'), _normalizeProps(_guardReactiveProps(_ctx.navigation ? { to: _ctx._url, target: _ctx.target } : {})), {
      default: _withCtx(() => [
        (_ctx.showImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showDuration && _ctx.isVideo && _ctx.videoDuration)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Play),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.videoDuration), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showTag && _ctx.tag)
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 1,
                    class: "news-card__tag",
                    tag: _ctx.tag,
                    "is-live": _ctx.isLive
                  }, null, 8, ["tag", "is-live"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Image, {
                class: "news-card__image",
                "image-url": _ctx.imageUrl,
                alt: _ctx.title,
                loading: "lazy"
              }, null, 8, ["image-url", "alt"]),
              (_ctx.showGalleryBadge && _ctx.isGallery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_GalleryFull),
                    _hoisted_6
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          (_ctx.showTag && _ctx.tag)
            ? (_openBlock(), _createBlock(_component_Tag, {
                key: 0,
                class: _normalizeClass({ 'news-card__tag--mobile': _ctx.showImage }),
                tag: _ctx.tag,
                "is-live": _ctx.isLive
              }, null, 8, ["class", "tag", "is-live"]))
            : _createCommentVNode("", true),
          (_ctx.showTitle && _ctx.title)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.size === 'large' ? 'h3' : 'h3'), {
                key: 1,
                class: _normalizeClass(["news-card__title", { 'news-card__title--highlighted': _ctx.titleHighlighted }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (!_ctx.showMinuteByMinuteLead)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.showLead && _ctx.lead)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.lead,
                      class: _normalizeClass(["news-card__excerpt", { 'news-card__excerpt--cropped': _ctx.leadCropping }])
                    }, null, 10, _hoisted_7))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.showLead && _ctx.minuteByMinuteLength)
              ? (_openBlock(), _createBlock(_component_minute_by_minute_lead, {
                  key: 3,
                  class: "news-card__excerpt",
                  "content-id": _ctx.content.id,
                  length: _ctx.minuteByMinuteLength
                }, null, 8, ["content-id", "length"]))
              : _createCommentVNode("", true),
          (_ctx.showReleaseDate && _ctx.releaseDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$d(_ctx.releaseDate, 'long')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 16))
  ], 10, _hoisted_1))
}